import React from 'react';
import { SidebarMenuItem, SidebarMenuButton } from 'src/shared/components/ui/sidebar';
import { redirectToShopify } from 'src/shared/utils/redirect';
import loginStorageService from 'src/app/login/services/login-storage-service';
import config from 'src/config';
import { ShoppingCart as ShoppingCartOutlinedIcon } from 'lucide-react';

const ShopifyMenu = () => {
    // Shopify is a different origin, so this must be a real <a href> — react-router's <Link>
    // can't navigate off-app. Falls back to the old button + redirectToShopify() (which just
    // logs an error) on the rare misconfigured environment with no URL to link to.
    if (!config.shopifyRedirectUrl) {
        return (
            <SidebarMenuItem>
                <SidebarMenuButton tooltip='Shop' onClick={redirectToShopify}>
                    <ShoppingCartOutlinedIcon />
                    <span>Shop</span>
                </SidebarMenuButton>
            </SidebarMenuItem>
        );
    }

    return (
        <SidebarMenuItem>
            <SidebarMenuButton asChild tooltip='Shop'>
                <a href={config.shopifyRedirectUrl} onClick={() => loginStorageService.setRedirectPath('')}>
                    <ShoppingCartOutlinedIcon />
                    <span>Shop</span>
                </a>
            </SidebarMenuButton>
        </SidebarMenuItem>
    );
};

export default ShopifyMenu;
